import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from './base-service';
import { LoginResponseDTO } from '../model/login-response-dto';
import { UserDTO } from '../model/user-dto';
import { Router } from '@angular/router';

export type NonceResponse = {
  accountId: string,
  nonce: string
  signature: string
}
@Injectable({
  providedIn: 'root'
})
export class LoginService extends BaseService {

  constructor(http: HttpClient, router: Router) {
    super(http, router)
  }

  login(user: UserDTO): Promise<LoginResponseDTO> {
    return new Promise<LoginResponseDTO>((resolve, reject) => {
      this.post<LoginResponseDTO>("auth/login", user, undefined, false)
        .subscribe({
          next: (data: LoginResponseDTO) => {
            resolve(data);
          },
          error: (response: HttpErrorResponse) => {
            reject(new Error('Login failed due to an HTTP error'))
          }
        })
    })
  }

  loginMetamask(nonce: string, accountId: string, signature: string): Promise<LoginResponseDTO> {
    let httpParams = new HttpParams()
      .set("accountId", accountId)
      .set("nonce", nonce)
      .set("signature", signature);
    let request = this.post<LoginResponseDTO>("auth/login-metamask", undefined, httpParams, false);
    return this.apiCall(request);
  }

  getNonce(accountId: string): Promise<NonceResponse> {
    let httpParams = new HttpParams()
      .set("accountId", accountId);
    let request = this.post<NonceResponse>("nonce", undefined, httpParams, false)
    return this.apiCall(request).then((res) => {
      res.accountId = accountId
      return res
    });
  }
}
